import $ from 'jquery';

import includes from 'lodash/includes';

export const isMobile = {
  Android: function() {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return (
      navigator.userAgent.match(/BlackBerry/i) ||
      (
        navigator.userAgent.match(/BB10/i) &&
        navigator.userAgent.match(/Mobile/i)
      )
    );
  },
  iOS: function() {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return !!navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return !!navigator.userAgent.match(/IEMobile/i);
  },
  isAnyRealDevice: function(){
    return (
      isMobile.Android() || 
      isMobile.BlackBerry() || 
      isMobile.iOS() || 
      isMobile.Opera() || 
      isMobile.Windows()
    );
  }

};
  
export const isIE = {
  any: function(){
    return isIE.lessThanTen() || isIE.greaterThanNine();
  },
  
  lessThanTen: function(){
    return $.browser.msie && $.browser.version < 10;
  },
  
  greaterThanNine: function(){
    return (
      ($.browser.msie && $.browser.version > 9) ||
      !(window.ActiveXObject) && 'ActiveXObject' in window //ie 11
    );
  }
};
  
export const os = {
  isWin2K: ()=> /windows nt 5.0/.test(navigator.userAgent.toLowerCase()),
  isXP: ()=> /windows nt 5.1/.test(navigator.userAgent.toLowerCase()),
  isVista: ()=> /windows nt 6.0/.test(navigator.userAgent.toLowerCase()),
  isWin7: ()=> /windows nt 6.1/.test(navigator.userAgent.toLowerCase()),
  isWin8: ()=> /windows nt 6.2/.test(navigator.userAgent.toLowerCase()),
  isWin81: ()=> /windows nt 6.3/.test(navigator.userAgent.toLowerCase()),
  isOSX: ()=> includes(['macintosh', 'macintel', 'macppc', 'mac68k'], navigator.platform.toLowerCase()) // https://stackoverflow.com/a/38241481
};

export const isTouchDevice = function() {
  return !!('ontouchstart' in window || // works on most browsers 
            navigator.msMaxTouchPoints); // works on ie10
};

export default {
  isMobile,
  isIE,
  isTouchDevice,
  os
};
